import { supabase } from "@/lib/supabase";

/**
 * Fire-and-forget marker that this participant has opened the feed
 * at least once. Idempotent on the server — first call sets
 * feed_viewed_at; later calls are no-ops. Used by the E3/E4 push
 * triggers in meetup-push-scheduler.
 */
export async function recordFeedView(participantId: string): Promise<void> {
  try {
    await supabase.rpc("record_feed_view", {
      p_participant_id: participantId,
    });
  } catch {
    /* non-critical */
  }
}

/**
 * Fire-and-forget pitch view tracker. Called from FeedCard once a
 * participant actually opens the pitch video (canplay reached). The
 * server-side RPC dedups by (viewer, target, day) so re-watching is
 * a no-op — re-plays within the same day don't inflate the count.
 *
 * Failure is swallowed: a missed view is non-critical, and the user
 * shouldn't see an error toast for a background analytics call.
 */
export async function trackPitchView(
  viewerParticipantId: string,
  targetParticipantId: string,
): Promise<void> {
  try {
    await supabase.rpc("track_pitch_view", {
      p_viewer_participant_id: viewerParticipantId,
      p_target_participant_id: targetParticipantId,
    });
  } catch {
    /* non-critical */
  }
}
